package com.eladfinish.bible.contest.screens.settings.ui.preferences

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Switch
import androidx.compose.material3.SwitchDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorAccent
import com.eladfinish.bible.contest.common.settings.KeyValueSettings
import com.eladfinish.bible.contest.ui.extensions.conditional
import dev.icerock.moko.resources.compose.colorResource

@Composable
fun PreferenceSwitch(
    title: String,
    key: String,
    defaultValue: Boolean,
    summaryOn: String,
    summaryOff: String,
    enabled: Boolean = true,
    settings: KeyValueSettings,
    /** Called after the new state is saved. */
    onCheckedChange: (Boolean) -> Unit = {},
) {
    var checked by remember { mutableStateOf(settings.getBoolean(key, defaultValue)) }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 8.dp)
            .conditional(enabled) {
                clickable {
                    checked = !checked
                    settings.putBoolean(key, checked)
                    onCheckedChange(checked)
                }
            }
            .conditional(!enabled) {
                alpha(0.5f)
            },
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(modifier = Modifier.weight(1f)) {
            Text(
                text = title,
                style = MaterialTheme.typography.bodyLarge,
            )
            Text(
                text = if (checked) summaryOn else summaryOff,
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
        Spacer(modifier = Modifier.width(8.dp))
        Switch(
            checked = checked,
            onCheckedChange = {
                checked = it
                settings.putBoolean(key, it) // Save the new state
                onCheckedChange(it)
            },
            colors = SwitchDefaults.colors(
                checkedTrackColor = colorResource(SharedRes.colors.colorAccent),
            ),
            enabled = enabled,
        )
    }
}
